import Spinner from '../design-system/spinner';

const BUTTON_LOADING_CLASS_NAME = 'btn--loading';
const SPINNER_CLASS_NAME = '.js-spinner';
const DEFAULT_TIMEOUT_MS = 10_000;
const TIMEOUT_ERROR = new Error('loading-state-timeout');

const addFixedWidth = (target) => {
  const boundingRect = target.getBoundingClientRect();

  target.style.width = `${Math.round(boundingRect.width)}px`;
};

const removeFixedWidth = (target) => { target.style.width = ''; };

const startLoading = (target) => {
  if (!target || target.classList.contains(BUTTON_LOADING_CLASS_NAME)) {
    return;
  }

  const color = target.classList.contains('btn--outline')
    ? { color: 'red' }
    : { color: 'white' };

  const spinner = new Spinner(color);

  addFixedWidth(target);

  target.classList.add(BUTTON_LOADING_CLASS_NAME);
  target.appendChild(spinner.build());
};

const clearLoadingState = (target) => {
  if (!target || !target.classList.contains(BUTTON_LOADING_CLASS_NAME)) {
    return;
  }

  const spinnerElement = target.querySelector(SPINNER_CLASS_NAME);

  removeFixedWidth(target);
  target.classList.remove(BUTTON_LOADING_CLASS_NAME);

  if (spinnerElement && spinnerElement.parentNode === target) {
    target.removeChild(spinnerElement);
  }
};

const hasLoadingState = (target) => Boolean(target && target.classList.contains(BUTTON_LOADING_CLASS_NAME));

const toTargets = (target) => (Array.isArray(target) ? target : [target]);

const withLoadingState = async (target, asyncFn, { timeoutMs = DEFAULT_TIMEOUT_MS } = {}) => {
  const targets = toTargets(target);

  targets.forEach(startLoading);

  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      // eslint-disable-next-line no-console
      console.warn(`withLoadingState: timed out after ${timeoutMs}ms`, target);
      reject(TIMEOUT_ERROR);
    }, timeoutMs);
  });

  try {
    return await Promise.race([asyncFn(), timeoutPromise]);
  } finally {
    clearTimeout(timeoutId);
    targets.forEach(clearLoadingState);
  }
};

const addNavigationLoadingState = (target, { maxMs = DEFAULT_TIMEOUT_MS } = {}) => {
  startLoading(target);

  setTimeout(() => {
    if (target.classList.contains(BUTTON_LOADING_CLASS_NAME)) {
      // eslint-disable-next-line no-console
      console.warn(`addNavigationLoadingState: timed out after ${maxMs}ms`, target);
      clearLoadingState(target);
    }
  }, maxMs);
};

if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) {
      return;
    }

    document
      .querySelectorAll(`.${BUTTON_LOADING_CLASS_NAME}`)
      .forEach(clearLoadingState);
  });
}

export {
  withLoadingState,
  addNavigationLoadingState,
  clearLoadingState,
  hasLoadingState
};
